import React, { useRef } from "react";
import { Player } from "../../interfaces/Player.Interface";
import image from "../../img/player_default.png";
import { useDrag } from "react-dnd";

interface Props {
  player: Player;
}

export default function TeamCardPlayerComponent(props: Props) {
  const { player } = props;
  const ref = useRef(null);
  const [{ isDragging }, drag] = useDrag({
    item: { type: "player", id: player.playerId },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(ref);

  return (
    <div
      ref={ref}
      style={{ opacity }}
      key={player.playerId}
      className="team-player-element"
    >
      <div className="jersey-number">{player.jerseyNumber}</div>
      <img alt="" src={player.imageUrl || image} />
      <div>{player.firstName}</div>
    </div>
  );
}
